// removed by extract-text-webpack-plugin
module.exports = {"container":"PrescriptionForm__container___2eOM-","formContainer":"PrescriptionForm__formContainer___31glV","tableContainer":"PrescriptionForm__tableContainer___2Nk-s","table":"PrescriptionForm__table___1h-c7","rowLabel":"PrescriptionForm__rowLabel___3zaqG","jsonButtonContainer":"PrescriptionForm__jsonButtonContainer___3lD32","buttonsContainer":"PrescriptionForm__buttonsContainer___2o1c5"};


//////////////////
// WEBPACK FOOTER
// ./study_coordinator/src/components/prescription/PrescriptionForm.css
// module id = 1206
// module chunks = 0